<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉时间</div>
          <div class="right">{{item.complain_time}}</div>
        </div>
        <div class="coordinatedResults border_bottom">
            <div class="title">退回理由</div>
            <div class="option">
                <van-RadioGroup
                v-model="isSplit"
                style="margin-top:15px"
                >
                <van-Radio name="1">根据所属地原则，不在本辖区管辖范围内</van-Radio>
                <van-Radio name="2">投诉对象不明确或错误</van-Radio>
                <van-Radio name="3">无法联系游客</van-Radio>
                <van-Radio name="4">其他</van-Radio>
                </van-RadioGroup>
            </div>
        </div>
      </div>
      <div class="remark">
        <div class="titleName">退回原因</div>
        <div class="notAccepted">
          <van-field placeholder="请输入退回原因..." type="textarea" maxlength="500" v-model="reson"/>
          <!-- <span class="total">0/500</span> -->
        </div>
      </div>
      <div class="btn">
        <div class="submit" @click="send">
          <van-button type="primary">确认</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import util from '../../../../utils/common'
    import api from '../../../../service/modules/complaint';
    export default {
        data () {
            return {
                item: util.getJsonLocal('item'),
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                currentTotal: 0,
                isSplit: '', // 选择哪种理由
                reson: ''
            };
        },
        created () {

        },
        methods: {
            send () {
                // let userInfo = this.$store.state.complaint.userInfo
                if (this.reson.trim().length === 0) {
                    this.$Toast('请输入退回原因');
                }
                const data = {
                    'main_complain_number': util.getJsonLocal('item').main_complain_number,
                    'complain_number': util.getJsonLocal('item').complain_number,
                    'complain_12301_number': util.getJsonLocal('item').complain_12301_number,
                    'type': 'transfer',
                    'clause': this.isSplit,
                    'note': this.reson.trim()
                }
                api.accept(data).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast('操作成功');
                        // this.$router.go(-2);
                        if(!this.isback){
                            this.$router.go(-2);
                          }else{
                              this.$router.back();
                              this.$set(this.item,'btns',[]);
                              util.setJsonLocal('item',this.item);
                          }
                        // this.$router.push({
                        //     path: '/complaint/workerListFirst',
                        //     query: {
                        //         userInfo: userInfo
                        //     }
                        // })
                    }
                })
            }

        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .whetherApplyAplitting {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
        }
      }
      .coordinatedResults {
          width: 100%;
          padding: 14px 0;
          font-size: 14px;
          .title {
            color: #aaa;
          }
          .van-radio-group {
              padding-left: 20px;
              margin-top: 0;
              .van-radio {
                  margin-top: 10px;
              }
          }
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        position: relative;
        .van-cell {
          font-size: 12px;
          background: #efeded;
          border-radius: 7px;
        }
        .total{
              position: absolute;
              bottom:6px;
              right:6px;
          }
      }
    }
    .btn {
      margin-top: 14px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
